var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCategory9 = function SvgCategory9(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "category9_svg__w-full category9_svg__h-full",
    viewBox: "0 0 68 56"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#727277",
    strokeMiterlimit: 10,
    strokeWidth: 1.6,
    clipPath: "url(#category9_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.22 45.267c-6.846 5.387-12.215 8.514-16.396 9.546a9.9 9.9 0 0 1-2.814.41 9.8 9.8 0 0 1-2.804-.41c-4.172-1.022-9.54-4.15-16.416-9.546-.04-.029-.07-.058-.11-.087C1.427 33.773-2.355 22.279 3.423 11.028 6.507 4.97 13.792 1.531 19.25.918 24.48.322 29.76 1.637 34 4.511 38.26 1.638 43.54.332 48.74.917c5.458.624 12.743 4.053 15.837 10.111C70.355 22.27 66.563 33.764 53.32 45.18c-.04.029-.07.058-.11.087zM34 41.729v-27.46M19.929 28.004h28.142"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "category9_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h68v56H0z"
  })))));
};
export default SvgCategory9;